import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Switch from "react-switch";
import AddVendorUser from "./AddVendorUser";
import { vendorRoleOptionsFromIds } from "../../../../constant/commonConstants";
import { EditSvg, EmailSvg } from "../../../../components/CommonSvg";
import ViewTable from "../../../../components/Common/ViewTable";
import CustomisedModal from "../../../../components/Modal/CustomisedModal";
import { commonConfirmBox } from "../../../../helper/messagehelpers";
import {
  activeInactiveVendorUserRequest,
  getVendorUserListRequest,
  resendVendorUserEmailRequest,
} from "../../../../redux/admin/vendorUser/action";

function VendorUsers({
  vendorDetails,
  getVendorUserList,
  vendorUserList,
  totalVendorUsers,
  activeInactiveVendorUser,
  resendVendorUserEmail,
}) {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [searchData, setSearchData] = useState("");
  const [modalView, setModaleView] = useState(false);
  const [isEdit, setIsEdit] = useState(null);
  const [formMode, setFormMode] = useState(null);

  const handleModalToggle = () => {
    setModaleView(!modalView);
  };

  const handleEditModalToggle = (data) => {
    setIsEdit(data);
    setModaleView(!modalView);
  };

  const dispatchData = {
    vendorId: id,
    searchText: searchData,
    pagination: {
      limit: dataPerPage,
      page: currentPage,
      orderKey: "createdDate",
      orderBy: "DESC",
    },
  };

  const columns = [
    {
      dataField: "contactName",
      text: "User Name",
      sort: true,
    },
    {
      dataField: "userEmail",
      text: "Email Address",
      sort: true,
    },
    {
      dataField: "phoneNumber",
      text: "Phone Number",
      sort: true,
      formatter: (cell, row) => <>{row.phoneNumber || "-"}</>,
    },
    // {
    //   dataField: "createdDate",
    //   text: "Created Date",
    //   sort: true,
    //   formatter: (cell, row) => <>{row.createdDate}</>,
    // },
    {
      dataField: "roleID",
      text: "Permissions",
      classes: "vendor_user_permissions",
      headerClasses: "vendor_user_permissions",
      formatter: (cell, row) => {
        const roles = vendorRoleOptionsFromIds(row.roleID);
        return roles.length > 0 ? (
          <div className="vendor_user_roles">
            {roles.map((role) => (
              <span className="vendor_role_badge" key={role.value}>
                {role.label}
              </span>
            ))}
          </div>
        ) : (
          <>-</>
        );
      },
    },
    {
      dataField: "isActive",
      text: "Status",
      headerClasses: "text-center",
      sort: true,
      formatter: (cell, row) => (
        <div
          className="text-center"
          onClick={(e) => {
            if (e && e.stopPropagation) {
              e.stopPropagation();
            }
          }}
        >
          <Switch
            className={`react-switch justify-content-center switch-sm ${
              row.isActive && "isActive"
            }`}
            onChange={async (e) => {
              if (e && e.stopPropagation) {
                e.stopPropagation();
              }
              const response = await commonConfirmBox(
                "",
                undefined,
                undefined,
                !row.isActive
                  ? `<h5 className="w-100">Do you want to activate this user?</h5> Name: ${row.contactName} <br/> Email: ${row.userEmail}`
                  : `<h5 className="w-100">Do you want to deactivate this user?</h5> Name: ${row.contactName} <br/> Email: ${row.userEmail}`
              );
              if (response) {
                activeInactiveVendorUser({
                  vendorUserId: row.vendorUserId,
                  isActive: !row.isActive,
                  dispatchData,
                });
              }
            }}
            type="checkbox"
            id="custom-switch"
            checked={row.isActive}
          />
        </div>
      ),
    },
    {
      dataField: "Action",
      text: "",
      headerClasses: "action_col",
      formatter: (cell, row) => (
        <div className="action_col text-center">
          <button
            className="my-tooltip btn btn-link resend_btn"
            data-tooltip-content={"Resend Email"}
            onClick={(e) => {
              if (e && e.stopPropagation) {
                e.stopPropagation();
              }
              resendVendorUserEmail({
                vendorUserId: row.vendorUserId,
                dispatchData,
              });
            }}
          >
            <EmailSvg />
          </button>

          <button
            className="my-tooltip btn btn-link edit_btn"
            data-tooltip-content={"Edit"}
            onClick={(e) => {
              if (e && e.stopPropagation) {
                e.stopPropagation();
              }
              handleEditModalToggle(row);
            }}
          >
            <EditSvg />
          </button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getVendorUserList(dispatchData);
  }, [id, dataPerPage, currentPage, searchData]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchData]);

  const vendorName = state?.name || "";
  const heading = vendorName ? (
    <>
      Vendor Users
      <span className="vendor_users_heading_name">{vendorName}</span>
    </>
  ) : (
    "Vendor Users"
  );

  return (
    <>
      <ViewTable
        data={vendorUserList}
        columns={columns}
        dataPerPage={dataPerPage}
        currentPage={currentPage}
        setDataPerPage={setDataPerPage}
        setCurrentPage={setCurrentPage}
        pagination={true}
        totalRecords={totalVendorUsers}
        rowClassName={"cursor-pointer"}
        Header={true}
        back={() => {
          navigate("/admin/vendor-list", {
            /* hand the list back exactly what it gave us, so Back returns to
               the page and filter the user left, not to a fresh first page */
            state: { listState: state?.listState },
          });
        }}
        rowEvents={(e, row) => {
          handleEditModalToggle(row);
        }}
        setSearchData={setSearchData}
        updateData={() => {
          setSearchData("");
          setCurrentPage(1);
        }}
        hedingName={heading}
        searchBar={true}
        addModalData={handleModalToggle}
        buttonNameModal={"Add Vendor User"}
      />
      {modalView && (
        <CustomisedModal
          modalView={modalView}
          customClass={`category-modal vendor-user-modal${
            formMode === "new" ? " is_wide" : ""
          }`}
          modalName={isEdit ? "Edit Vendor User" : "Add Vendor User"}
          onModalDismiss={() => {
            setModaleView(false);
            setIsEdit(null);
            setFormMode(null);
          }}
        >
          <AddVendorUser
            onModeChange={setFormMode}
            onModalDismiss={() => {
              setModaleView(false);
            }}
            data={isEdit}
            setIsEdit={setIsEdit}
            modalView={modalView}
            dispatchData={dispatchData}
          />
        </CustomisedModal>
      )}
    </>
  );
}

const mapStateToProps = ({ vendor, adminVendorUser }) => {
  let vendorDetails = vendor.vendor?.list ? vendor.vendor.list : [];

  let vendorUserList =
    adminVendorUser?.getVendorUsers?.list?.length > 0
      ? adminVendorUser.getVendorUsers.list.map((vendorUser) => ({
          ...vendorUser,
          id: vendorUser.vendorUserId,
        }))
      : [];
  let totalVendorUsers = adminVendorUser?.getVendorUsers?.totalRecords || 0;

  return {
    vendorDetails,
    vendorUserList,
    totalVendorUsers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVendorUserList: (data) => dispatch(getVendorUserListRequest(data)),
    activeInactiveVendorUser: (data) =>
      dispatch(activeInactiveVendorUserRequest(data)),
    resendVendorUserEmail: (data) =>
      dispatch(resendVendorUserEmailRequest(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(VendorUsers);
